module.exports = __webpack_public_path__ + "static/media/step4.9555f62a.svg";